import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Table, Params } from 'nallian-table-builder-ui';
import apiRoutes from '../../../../app/api/routes';
import { ACTIONS, COMMUNITY_DETAIL_TABS } from '../../../communities/constants';
import { PRINCIPAL_ACTIONS, TABS } from '../../../organisations/constants';
import TextFilter from '../../../app/components/TextFilter';
import { INFINITE_SCROLL } from '../../constants';

const FeatureAssignments = ({ appId, installationId, featureId }) => {
  const { t } = useTranslation();

  if (!appId || !installationId || !featureId) {
    return <span>{t('noAssignmentsFound')}</span>;
  }

  return (
    <Table
      resource={`featureAssignments_${appId}_${installationId}_${featureId}`}
      url={apiRoutes.featureAssignments(appId, installationId, featureId)}
      noResultsMessage={t('noAssignmentsFound')}
      pageSize={50}
      infiniteScroll={INFINITE_SCROLL}
      idProp="principal.id"
      filtered
      sorted
      resizable
    >
      <Params.String
        name="principal.fullName"
        label={t('principalName')}
        sortName="principalName"
        filterName="principalName"
        width="20rem"
        link={`/organisations/:organisation.id/${TABS.PRINCIPALS}/${PRINCIPAL_ACTIONS.DETAILS}/:principal.id`}
        grow
      />
      <Params.String
        name="principal.primaryEmailAddress"
        label={t('email')}
        width="16rem"
        noSort
        noFilter
        grow
      />
      <Params.String
        name="organisation.name"
        label={t('organisation')}
        sortName="organisationName"
        filterName="organisationName"
        link={`/organisations/:organisation.id/${TABS.DETAILS}`}
        width="18rem"
        grow
      />
      <Params.String
        name="community.name"
        label={t('community')}
        sortName="communityName"
        filterName="communityName"
        link={`/communities/${ACTIONS.EDIT}/:community.id/${COMMUNITY_DETAIL_TABS.DETAILS}`}
        width="15rem"
        filter={TextFilter}
      />
    </Table>
  );
};

FeatureAssignments.propTypes = {
  appId: PropTypes.string.isRequired,
  installationId: PropTypes.string.isRequired,
  featureId: PropTypes.string.isRequired,
};

export default FeatureAssignments;
